<template>
  <div>
    <div class="space-y-2">
      <div class="relative font-medium text-[15px]">
        <div class="h-[29px]">
          <span :id="`label-search-${uuid}`">{{ label }}</span>
        </div>
      </div>

      <div class="text-sm space-y-4">
        <fieldset class="relative" style="min-inline-size: auto">
          <legend class="sr-only">
            {{ legend }}
          </legend>
          <div class="">
            <BaseInput type="number" v-model="numericValue" @input="onChangeValue" />
          </div>
        </fieldset>
      </div>
    </div>
  </div>
</template>

<script>
export default defineNuxtComponent({
  setup() {
    const uuid = useId()
    const { isActiveFilter, searchForFacetValues, addFilter, deleteFilter } =
      useAlgoliaQueryBuilder()

    return {
      isActiveFilter,
      searchForFacetValues,
      addFilter,
      deleteFilter,
      uuid,
    }
  },
  props: {
    attributeName: {
      type: String,
      required: true,
    },
    operand: {
      type: String,
      default: '>=',
      validator: (val) => ['=', '>', '<', '>=', '<='].includes(val),
    },
    label: {
      type: String,
      required: true,
    },
    legend: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      numericValue: this.$route.query[this.attributeName]?.split('|')[1] ?? null,
    }
  },
  computed: {
    activeValue() {
      return this.$route.query[this.attributeName]?.split('|')[1] ?? null
    },
  },
  watch: {
    $route(newVal, oldVal) {
      if (newVal.name !== oldVal.name) {
        return
      }

      this.numericValue = this.activeValue
    },
  },
  methods: {
    onChangeValue() {
      if (this.numericValue) {
        this.addFilter(this.attributeName, `${this.operand}|${this.numericValue}`)
      } else {
        this.deleteFilter(this.attributeName)
      }
    },
  },
})
</script>
